import { has } from 'lodash-es'

import StrictObj from './strict-obj'
import extractRawElm from './extract-raw-elm'

const MATRIX_RE = /matrix\(.+,.+,.+,.+,(.+),(.+)\)/
const MATRIX3D_RE = /matrix3d\(.+,.+,.+,.+,.+,.+,.+,.+,.+,.+,.+,.+,(.+),(.+),(.+),.+\)/

const TRANSFORM = 'transform'

export function getTransformX($elm) {
  return getTransform($elm).transformX
}

export function getTransformY($elm) {
  return getTransform($elm).transformY
}

export function getTransform($elm) {
  const elm = extractRawElm($elm)
  const transform = window.getComputedStyle(elm)[TRANSFORM]

  let match = null
  if (MATRIX_RE.test(transform)) {
    match = MATRIX_RE.exec(transform)
  } else if (MATRIX3D_RE.test(transform)) {
    match = MATRIX3D_RE.exec(transform)
  }

  const transformX = has(match, 1) ? Math.round(parseFloat(match[1])) : 0
  const transformY = has(match, 2) ? Math.round(parseFloat(match[2])) : 0
  const transformZ = has(match, 3) ? Math.round(parseFloat(match[3])) : 0
  return StrictObj({ transformX, transformY, transformZ })
}
